module.exports = __webpack_public_path__ + "img/default.03846068.png";